import { DeleteOutlined, EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Pagination, Popconfirm, Row, Space, Table } from "antd";
import Search from "antd/lib/input/Search";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";
import RangePickers from "../../../components/DatePicker/RangePickers";
import { errorNotification } from "../../../components/notifications/alertNotification";
import { STATUSES } from "../../../config/constants/defaultValues";
import {
  deleteConfigurationalServiceRequest,
  getConfigurationalServiceListExportDataRequest,
  getConfigurationalServiceListRequest,
} from "../../../redux/systemConfigurationSlice";
import { ReactComponent as DownloadImage } from "../../../assets/images/download.svg";
import { JobRequestStyle } from "../../style";
import { SystemConfigurationWrapped } from "../style";
import ServiceDetailModal from "./ServiceDetailModal";
import ServiceEditModal from "./ServiceEditModal";
import ServiceCreateModal from "./ServiceCreateModal";

const ServiceConfiguration = () => {
  const dispatch = useDispatch();
  const { serviceStatus, serviceData, serviceError } = useSelector(
    (state) => state.systemConfiguration
  );
  const [search, setSearch] = useState();
  const [exportLoading, setExportLoading] = useState(false);
  const [modalData, setModelData] = useState();
  const [editModalData, setEditModelData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [dateRange, setDateRange] = useState("");

  useEffect(() => {
    if (serviceStatus !== STATUSES.LOADED) {
      dispatch(getConfigurationalServiceListRequest({}));
    }
  }, [dispatch]);

  const paginationOnChange = (data, pageSize) => {
    dispatch(
      getConfigurationalServiceListRequest({
        generalSearch: search,
        page: data,
        pageSize: pageSize,
        dateRange: dateRange,
      })
    );
  };

  const onDateChange = ({ dateRange }) => {
    setDateRange(dateRange);
    dispatch(
      getConfigurationalServiceListRequest({
        generalSearch: search,
        dateRange: dateRange,
      })
    );
  };

  const onSearch = (generalSearch) => {
    setSearch(generalSearch);
    dispatch(
      getConfigurationalServiceListRequest({
        generalSearch,
        dateRange: dateRange,
      })
    );
  };

  const exportToExcel = async () => {
    setExportLoading(true);
    try {
      const data = await dispatch(
        getConfigurationalServiceListExportDataRequest({
          generalSearch: search,
          dateRange: dateRange,
        })
      );

      let filtered = [...data.payload];

      const worksheet = XLSX.utils.json_to_sheet(
        filtered.map((record) => ({
          id: record.id,
          Title: record.title,
          Description: record.description,
          Image: record.service_image,
          created_at: record.created_at,
          updated_at: record.updated_at,
        }))
      );

      const currentDateTimeString = moment(new Date()).format(
        "MM-DD-YYYY-hh:mm-A"
      );
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(
        workbook,
        `acro-solar-DataSheet-${currentDateTimeString}.xlsx`
      );
    } catch (error) {
      errorNotification("Error while fetching or processing data:", error);
    } finally {
      setExportLoading(false); // Ensure that loading indicator is turned off, even in case of an error
    }
  };

  const showModal = (record) => {
    setModelData(record);
    setIsModalOpen(true);
  };

  const showEditModal = (record) => {
    setEditModelData(record);
    setIsEditModalOpen(true);
  };
  const showCreateModal = () => {
    setIsCreateModalOpen(true);
  };
  const deleteService = (id) => {
    dispatch(deleteConfigurationalServiceRequest(id));
    dispatch(getConfigurationalServiceListRequest({}));
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      width: "10%",
      // ...getColumnSearchProps('id'),
    },
    {
      title: "Service",
      dataIndex: "title",
      width: "50%",
      ellipsis: true,

      // render: (text) => <Text strong>{text.name}</Text>,
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      ellipsis: true,
      // render: (text) => moment(text).format('MM-DD-YYYY'),
      sorter: (a, b) => {
        // Convert the date strings to Date objects for comparison
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);

        return dateA - dateB; // To sort in ascending order
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "15%",
      render: (text, record) => (
        <Space>
          <span
            style={{
              color: "#112E3C",
              cursor: "pointer",
            }}
            className="job_view"
            onClick={() => showModal(record)}
          >
            <EyeOutlined />
          </span>
          <span
            style={{
              color: "#112E3C",
              cursor: "pointer",
            }}
            className="job_view"
            onClick={() => showEditModal(record)}
          >
            <i class="bi bi-pencil" />
          </span>
          <span
            style={{
              color: "#962020",
              cursor: "pointer",
            }}
            className="job_view"
          >
            <Popconfirm
              Popconfirm
              title="Are you sure you want to delete this?"
              okText="Delete"
              placement="top"
              onConfirm={() => deleteService(record.id)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </span>
        </Space>
      ),
    },
  ];

  return (
    <JobRequestStyle>
      <div className="layout-content">
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} className="mb-24">
            <div className="row  pb-3 pb-sm-5">
              <div className="col-sm-9">
                <div className="heading">Service List</div>
              </div>
              <div className="col-sm-3">
                <button
                  className="approved_btn_w px-2 border-0 mt-2 mt-sm-0"
                  onClick={() => showCreateModal()}
                >
                  Create New
                </button>
              </div>
            </div>
            <div className="col-xl-5 col-lg-7 col-md-5 col-sm-12">
              <RangePickers
                name="Date_Posted"
                req={false}
                labelText="Date Range"
                onChange={(_, dateStrings) => {
                  if (dateStrings[0] == "") {
                    onDateChange({ dateRange: null });
                  } else {
                    onDateChange({
                      dateRange: `${dateStrings[0]} , ${dateStrings[1]}`,
                    });
                  }
                }}
                on
              />
            </div>
            <SystemConfigurationWrapped>
              <div className="row pb-3 ">
                <div className="col-sm-6 p-sm-0">
                  <Search
                    onSearch={onSearch}
                    onChange={(value) => setSearch(value.value)}
                    prefix={<SearchOutlined width={"20px"} />}
                    allowClear
                    placeholder="Search"
                    value={search}
                    style={{
                      marginRight: "15px",
                    }}
                  />
                </div>
                <div className="col-sm-6 mt-3 mt-sm-0 text-end">
                  <Button
                    className="reject_btn"
                    loading={exportLoading}
                    onClick={exportToExcel}
                  >
                    Export <DownloadImage />
                  </Button>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 p-sm-0">
                  <Table
                    loading={serviceStatus === STATUSES.LOADING}
                    dataSource={serviceData?.data ?? []}
                    columns={columns}
                    bordered={true}
                    indentSize={33}
                    pagination={false} // Disable pagination
                    scroll={{ x: 600 }}
                  />
                </div>
              </div>
            </SystemConfigurationWrapped>
          </Col>
        </Row>
      </div>

      {
        <div className="featureBg__border p-2 d-flex justify-content-center w-100 pb-5">
          <Pagination
            current={serviceData?.meta.page ?? 1}
            pageSize={serviceData?.meta.per_page ?? 10}
            total={serviceData?.meta.total}
            showSizeChanger={true}
            onChange={paginationOnChange}
            onShowSizeChange={paginationOnChange}
          />
        </div>
      }
      <ServiceDetailModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        modalData={modalData}
      />
      <ServiceEditModal
        isModalOpen={isEditModalOpen}
        setIsModalOpen={setIsEditModalOpen}
        modalData={editModalData}
      />
      <ServiceCreateModal
        isModalOpen={isCreateModalOpen}
        setIsModalOpen={setIsCreateModalOpen}
      />
    </JobRequestStyle>
  );
};

export default ServiceConfiguration;
